import { render, staticRenderFns } from "./LiefengCascaderCity.vue?vue&type=template&id=537f0f2e&"
import script from "./LiefengCascaderCity.vue?vue&type=script&lang=js&"
export * from "./LiefengCascaderCity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports